import {environment} from '../../../environments/environment';

export function normalizeBaseUrl(value: string): string {
  return value.trim().replace(/\/+$/, '');
}

export function buildApiUrl(path: string): string {
  const baseUrl = normalizeBaseUrl(environment.apiBaseUrl ?? '');
  if (!baseUrl) {
    return path;
  }

  return `${baseUrl}${path}`;
}
